import { Tokens, UserInfo } from "../models/Interfaces";
import { STAY_LOGGED_IN_PW } from "../globals";
import { globalStore } from "../jotai/store";
import db, { Key } from "../database/database";
import { UserResponseDto } from "@docket/consumer-app-client-typescript-axios";
import { tokensAtom, userAtom } from "../jotai/atoms";

/**
 * Handles the three operations we need to perform with the user object upon login. Namely that is
 * - Setting up the database's crypto key based on the user so that we can start storing data.
 * - Saving the user in the Jotai atom
 * - Saving the user's tokens in the Jotai atom
 */
export const updateCryptoKeyAndUserAndTokens = async (user: UserResponseDto, tokens: Tokens) => {
  await db().updateCryptoKey(user, STAY_LOGGED_IN_PW);
  await globalStore.set(userAtom, user);
  await globalStore.set(tokensAtom, tokens);
};

export const isAuth = async () => {
  const unlocked = await db().unlock(STAY_LOGGED_IN_PW);
  if (!unlocked) {
    return false;
  }

  const user = await db().getItem<UserInfo>(Key.UserInfo);
  const tokens = await db().getItem<Tokens>(Key.Tokens);
  /**
   * We should also consider ourselves not authenticated if the user
   * account that we have saved is missing the new access/refresh token
   * pair. This will correctly log the user out in case they had logged in
   * prior to our rollout of the new tokens (with the setting checked to
   * stay logged in). If we consider them logged in, we get into a whole mess
   * of other problems when trying to make requests without the new tokens.
   */
  return !!user && !!tokens;
};
